import React, { useState, useEffect } from "react"
import ReactDOM from "react-dom"
import "./frontend.min.css"

document.addEventListener("DOMContentLoaded", function () {
  const divsToUpdate = document.querySelectorAll(".tabmenuTeams-update-me")

  divsToUpdate.forEach(function (div) {
    const data = JSON.parse(div.querySelector("pre").innerHTML)
    ReactDOM.render(<TabmenuTeams {...data} />, div)
    div.classList.remove("tabmenuTeams-update-me")
  })

  function TabmenuTeams(props) {
    function changeTab(e) {
        const tabIndex = e.target.dataset.tabindex 
        e.target.parentNode.parentNode.querySelectorAll("[data-tabstatus='active']").forEach(tab => {
            tab.dataset.tabstatus = "inactive"
        })
        e.target.parentNode.parentNode.querySelectorAll('[data-tabindex="' + tabIndex + '"]').forEach(tab => {
            tab.dataset.tabstatus = "active"
        })
    }

    const tabRef = React.createRef();
    const [slider, setSlider] = useState(false)
    const [mobileClass, setMobileClass] = useState("desktop")
    const [overflow, setOverflow] = useState("unset")

    useEffect(() => {
        MobileSlides()
    })
    window.addEventListener('resize', () => {
        MobileSlides()
    });
    const MobileSlides = () => {
        if (tabRef.current) {
            if (tabRef.current.scrollWidth > tabRef.current.offsetWidth) {
                setSlider(true)
                setMobileClass("mobile")
                setOverflow("scroll")
            }
            else {
                setSlider(false)
                setMobileClass("desktop")
                setOverflow("unset")
            }
        }
    }
    
    const scrollToNext = (e) => {
        let parent = e.target.closest(".tabmenu-frontend")
        let activeTab = parent.querySelector('[data-tabstatus="active"]')
        activeTab.dataset.tabstatus = "inactive"
        if (activeTab.nextElementSibling) {
            activeTab.nextElementSibling.dataset.tabstatus = "active"
        }
        else {
            parent.querySelector('[data-tabstatus="inactive"]').dataset.tabstatus = "active"
        }
        parent.querySelector(".tabHeadWrapper").scrollLeft = parent.querySelector('[data-tabstatus="active"]').offsetLeft
    }
    const scrollToPrev = (e) => {
        let parent = e.target.closest(".tabmenu-frontend")
        let activeTab = parent.querySelector('[data-tabstatus="active"]')
        activeTab.dataset.tabstatus = "inactive"
        if (activeTab.previousElementSibling) {
            activeTab.previousElementSibling.dataset.tabstatus = "active"
        }
        else {
            parent.querySelector('.tabHeadWrapper').lastElementChild.dataset.tabstatus = "active"
        }
        parent.querySelector(".tabHeadWrapper").scrollLeft = parent.querySelector('[data-tabstatus="active"]').offsetLeft
    }
    const openContent = (e) => {
        if (e.target.previousElementSibling.classList.contains("visible")) {
            e.target.classList.remove("visible")
            e.target.previousElementSibling.classList.remove("visible")
        }
        else {
            e.target.classList.add("visible")
            e.target.previousElementSibling.classList.add("visible")
        }
    }
    document.addEventListener("click", (e) => {
        console.log(e.target)
    })

    return (
        <div className={"tabmenu-frontend tabmenu-teams " + mobileClass}>
            {slider &&
                <div className="carouselNav">
                    <div onClick={(e) => scrollToPrev(e)}
                    className="carousel__prev">
                        <svg id="a" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" width="7.72" height="13.43" viewBox="0 0 7.72 13.43">
                            <path d="M1,13.43c-.26,0-.51-.1-.71-.29-.39-.39-.39-1.02,0-1.41L5.3,6.72,.29,1.71C-.1,1.32-.1,.68,.29,.29S1.32-.1,1.71,.29L7.42,6.01c.39,.39,.39,1.02,0,1.41L1.71,13.14c-.2,.2-.45,.29-.71,.29Z"/>
                        </svg>
                    </div>
                    <div onClick={(e) => scrollToNext(e)}
                    className="carousel__next">
                        <svg id="a" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" width="7.72" height="13.43" viewBox="0 0 7.72 13.43">
                            <path d="M1,13.43c-.26,0-.51-.1-.71-.29-.39-.39-.39-1.02,0-1.41L5.3,6.72,.29,1.71C-.1,1.32-.1,.68,.29,.29S1.32-.1,1.71,.29L7.42,6.01c.39,.39,.39,1.02,0,1.41L1.71,13.14c-.2,.2-.45,.29-.71,.29Z"/>
                        </svg>
                    </div>
                </div>
            }
            <div ref={tabRef} className="tabHeadWrapper" style={{overflowX: overflow}}>
                {
                props.tabHead ?
                props.tabHead.map(function (tab, index) {
                    let tabstatus = "inactive"
                    if (index == 0) {
                        tabstatus = "active"
                    }
                    return (
                        <div data-tabstatus={tabstatus} data-tabindex={index} onClick={changeTab} className="tabHead">
                            <span>{tab}</span>
                        </div>
                    )
                })
                :
                <div data-tabstatus="active" data-tabindex="0" className="tabHead">
                    Tab 1
                </div>
                }
            </div>  
            <div className="tabContentWrapper">
                {
                props.tabContent ?
                props.tabContent.map(function (tabWrap, index) {
                    let tabstatus = "inactive"
                    if (index == 0) {
                        tabstatus = "active"
                    }
                    return (
                        <div className="tabContent" data-tabstatus={tabstatus} data-tabindex={index}>
                            {tabWrap.map(function (tab, index) {
                                return (
                                    <div>
                                        <div className="mainContent">
                                            <div className="header">
                                                <figure>
                                                    <img src={tab[3]} alt="" />
                                                </figure>

                                                <div>
                                                    <p className="headline">{tab[0]}</p>
                                                    <p className="subline">{tab[1]}</p>
                                                </div>
                                            </div>
                                            <p className="content">{tab[2]}</p>
                                            {slider && 
                                                <div onClick={(e) => openContent(e)} className="openContent" >
                                                    <svg
                                                    id="a" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" width="7.72" height="13.43" viewBox="0 0 7.72 13.43">
                                                        <path d="M1,13.43c-.26,0-.51-.1-.71-.29-.39-.39-.39-1.02,0-1.41L5.3,6.72,.29,1.71C-.1,1.32-.1,.68,.29,.29S1.32-.1,1.71,.29L7.42,6.01c.39,.39,.39,1.02,0,1.41L1.71,13.14c-.2,.2-.45,.29-.71,.29Z"/>
                                                    </svg>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    )
                })
                :
                <div className="mainContent">
                    <p className="headline">Headline</p>
                    <p className="content">Inhalt</p>
                </div>
                }
            </div>
        </div>
    )
  }
})
